import script from "./recipe-name-cell.vue?vue&type=script&setup=true&lang=js"
export * from "./recipe-name-cell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__